import { FC, useEffect } from 'react';
import { useFormikContext } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import TableCell from '@mui/material/TableCell';
import DiskCleanupTool from 'components/DiskCleanupTool';
import DiskCleanupResult from 'components/DiskCleanupResult';

import { useAvoidSuspense } from 'lib';
import { useDiskCleanup } from 'components/DiskCleanupContext';
import Query, {
  DiskCleanupMediaRefetchQuery,
} from '__generated__/DiskCleanupMediaRefetchQuery.graphql';
import { DiskCleanupMedia_data$key } from '__generated__/DiskCleanupMedia_data.graphql';

import { DiskCleanupFormValues } from 'components/DiskCleanup';

type Props = {
  data: DiskCleanupMedia_data$key;
};

const DiskCleanupMedia: FC<Props> = props => {
  const { setStatus } = useDiskCleanup();

  const [data, { loading, refetch }] = useAvoidSuspense<
    DiskCleanupMediaRefetchQuery,
    DiskCleanupMedia_data$key
  >(
    graphql`
      fragment DiskCleanupMedia_data on Query
      @refetchable(queryName: "DiskCleanupMediaRefetchQuery") {
        diskCleanerScan(input: $input) @include(if: $scan) {
          media {
            ...DiskCleanupResult_cleanInfo
          }
        }
      }
    `,
    props.data,
    Query
  );

  const { values } = useFormikContext<DiskCleanupFormValues>();

  const { media } = values;

  useEffect(() => {
    if (!media.selected) return;

    refetch({
      scan: true,
      input: {
        media,
      },
    });
  }, [media, refetch]);

  useEffect(() => {
    setStatus('media', loading);
  }, [loading, setStatus]);

  return (
    <DiskCleanupTool name="media" title="Nepriskirtos nuotraukos">
      <TableCell></TableCell>

      <TableCell>
        {media.selected && (
          <DiskCleanupResult
            loading={loading}
            cleanInfo={data.diskCleanerScan?.media ?? null}
          />
        )}
      </TableCell>
    </DiskCleanupTool>
  );
};

export default DiskCleanupMedia;
